export default "__VITE_ASSET__DAgnqy2A__"